var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEastTimor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C12.0826 0 8.49476 1.40856 5.71338 3.74587L22.9565 16L5.71338 28.2541C8.49476 30.5914 12.0826 32 16 32C24.8365 32 32 24.8365 32 16C32 7.1635 24.8365 0 16 0Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68677 4.68628C-1.56161 10.9347 -1.56161 21.0653 4.68677 27.3138C7.26883 24.7317 9.75214 22.2484 16.0005 16L4.68677 4.68628Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43635 12.3347L6.87135 14.6392L9.8156 13.0352L8.37654 16.0633L10.8116 18.3679L7.48698 17.9349L6.04773 20.963L5.43229 17.6672L2.10767 17.2341L5.05179 15.6303L4.43635 12.3347Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEastTimor);
export default __webpack_public_path__ + "static/media/east-timor.653fcc3c.svg";
export { ForwardRef as ReactComponent };